module.exports = __webpack_public_path__ + "static/img/banner_solutions_optics.c71daba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/banner_solutions_optics.png
// module id = zpb4
// module chunks = 10